import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59790b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card__titles" }
const _hoisted_2 = { class: "card__name" }
const _hoisted_3 = { class: "card__stock" }
const _hoisted_4 = { class: "card__decoins" }
const _hoisted_5 = { class: "card__validation" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.2246 4.98517C15.989 4.43961 15.6493 3.94523 15.2244 3.5297C14.7993 3.11293 14.298 2.78173 13.7479 2.55411C13.1774 2.31715 12.5656 2.19586 11.9479 2.19728C11.0813 2.19728 10.2357 2.43458 9.50098 2.88282C9.3252 2.99005 9.1582 3.10782 9 3.23615C8.8418 3.10782 8.67481 2.99005 8.49902 2.88282C7.76426 2.43458 6.91875 2.19728 6.05215 2.19728C5.42813 2.19728 4.82344 2.31681 4.25215 2.55411C3.7002 2.78263 3.20273 3.11134 2.77559 3.5297C2.35019 3.94476 2.01037 4.43926 1.77539 4.98517C1.53105 5.55294 1.40625 6.15587 1.40625 6.77638C1.40625 7.36173 1.52578 7.97169 1.76309 8.5922C1.96172 9.11075 2.24648 9.64864 2.61035 10.1918C3.18691 11.0514 3.97969 11.9479 4.96406 12.8567C6.59531 14.3631 8.21074 15.4037 8.2793 15.4459L8.6959 15.7131C8.88047 15.8309 9.11777 15.8309 9.30234 15.7131L9.71895 15.4459C9.7875 15.402 11.4012 14.3631 13.0342 12.8567C14.0186 11.9479 14.8113 11.0514 15.3879 10.1918C15.7518 9.64864 16.0383 9.11075 16.2352 8.5922C16.4725 7.97169 16.592 7.36173 16.592 6.77638C16.5938 6.15587 16.4689 5.55294 16.2246 4.98517V4.98517ZM9 14.3227C9 14.3227 2.74219 10.3131 2.74219 6.77638C2.74219 4.98517 4.22402 3.53322 6.05215 3.53322C7.33711 3.53322 8.45156 4.2504 9 5.29806C9.54844 4.2504 10.6629 3.53322 11.9479 3.53322C13.776 3.53322 15.2578 4.98517 15.2578 6.77638C15.2578 10.3131 9 14.3227 9 14.3227Z",
    fill: "#ff5f71 "
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.6328 6.64686C21.3187 5.91945 20.8657 5.26027 20.2992 4.70624C19.7323 4.15055 19.064 3.70895 18.3305 3.40545C17.5699 3.0895 16.7541 2.92778 15.9305 2.92967C14.775 2.92967 13.6477 3.24608 12.668 3.84374C12.4336 3.9867 12.2109 4.14374 12 4.31483C11.7891 4.14374 11.5664 3.9867 11.332 3.84374C10.3523 3.24608 9.225 2.92967 8.06953 2.92967C7.2375 2.92967 6.43125 3.08905 5.66953 3.40545C4.93359 3.71014 4.27031 4.14842 3.70078 4.70624C3.13359 5.25965 2.6805 5.91898 2.36719 6.64686C2.04141 7.40389 1.875 8.2078 1.875 9.03514C1.875 9.81561 2.03438 10.6289 2.35078 11.4562C2.61563 12.1476 2.99531 12.8648 3.48047 13.589C4.24922 14.7351 5.30625 15.9305 6.61875 17.1422C8.79375 19.1508 10.9477 20.5383 11.0391 20.5945L11.5945 20.9508C11.8406 21.1078 12.157 21.1078 12.4031 20.9508L12.9586 20.5945C13.05 20.5359 15.2016 19.1508 17.3789 17.1422C18.6914 15.9305 19.7484 14.7351 20.5172 13.589C21.0023 12.8648 21.3844 12.1476 21.6469 11.4562C21.9633 10.6289 22.1227 9.81561 22.1227 9.03514C22.125 8.2078 21.9586 7.40389 21.6328 6.64686V6.64686Z",
    fill: "#ff5f71"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card__buttons" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 18.0007C5.9 18.0007 5.01 18.9007 5.01 20.0007C5.01 21.1007 5.9 22.0007 7 22.0007C8.1 22.0007 9 21.1007 9 20.0007C9 18.9007 8.1 18.0007 7 18.0007ZM17 18.0007C15.9 18.0007 15.01 18.9007 15.01 20.0007C15.01 21.1007 15.9 22.0007 17 22.0007C18.1 22.0007 19 21.1007 19 20.0007C19 18.9007 18.1 18.0007 17 18.0007ZM15.55 13.0007C16.3 13.0007 16.96 12.5907 17.3 11.9707L20.88 5.48073C20.9643 5.32916 21.0075 5.1582 21.0054 4.98479C21.0034 4.81137 20.956 4.6415 20.8681 4.49199C20.7803 4.34248 20.6549 4.21851 20.5043 4.13235C20.3538 4.04619 20.1834 4.00082 20.01 4.00073H5.21L4.27 2.00073H1V4.00073H3L6.6 11.5907L5.25 14.0307C4.52 15.3707 5.48 17.0007 7 17.0007H19V15.0007H7L8.1 13.0007H15.55ZM6.16 6.00073H18.31L15.55 11.0007H8.53L6.16 6.00073Z",
    fill: "white"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 18.0007C5.9 18.0007 5.01 18.9007 5.01 20.0007C5.01 21.1007 5.9 22.0007 7 22.0007C8.1 22.0007 9 21.1007 9 20.0007C9 18.9007 8.1 18.0007 7 18.0007ZM17 18.0007C15.9 18.0007 15.01 18.9007 15.01 20.0007C15.01 21.1007 15.9 22.0007 17 22.0007C18.1 22.0007 19 21.1007 19 20.0007C19 18.9007 18.1 18.0007 17 18.0007ZM15.55 13.0007C16.3 13.0007 16.96 12.5907 17.3 11.9707L20.88 5.48073C20.9643 5.32916 21.0075 5.1582 21.0054 4.98479C21.0034 4.81137 20.956 4.6415 20.8681 4.49199C20.7803 4.34248 20.6549 4.21851 20.5043 4.13235C20.3538 4.04619 20.1834 4.00082 20.01 4.00073H5.21L4.27 2.00073H1V4.00073H3L6.6 11.5907L5.25 14.0307C4.52 15.3707 5.48 17.0007 7 17.0007H19V15.0007H7L8.1 13.0007H15.55ZM6.16 6.00073H18.31L15.55 11.0007H8.53L6.16 6.00073Z",
    fill: "white"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Remover ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HoverGallery = _resolveComponent("HoverGallery")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card', { inBag: _ctx.bagIncludes(_ctx.product) }])
  }, [
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotToProductDetail(_ctx.product))),
      class: "card__information"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['card__image', _ctx.isProductOutOfStock(_ctx.product) ? 'disabled' : ''])
      }, [
        _createVNode(_component_HoverGallery, {
          gallery: _ctx.product.imagesUrl,
          "color-border": "transparent"
        }, null, 8, ["gallery"])
      ], 2),
      _createElementVNode("div", {
        class: "card__content",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotToProductDetail(_ctx.product)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.formatDecoins(_ctx.product.decoins)), 1),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isFavorite(_ctx.product))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "card__favorite--unchecked",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addToFavorites(_ctx.product)), ["stop"]))
                  }, _hoisted_7))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "card__button-remove-favorite--checked",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.removeFromFavoriteList(_ctx.product)), ["stop"]))
                  }, _hoisted_9))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!_ctx.bagIncludes(_ctx.product))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass([
          'card__button-add',
          _ctx.hasEnoughDecoins(_ctx.product) ||
          _ctx.isProductOutOfStock(_ctx.product) ||
          !_ctx.checkEnough(_ctx.product)
            ? 'disabled'
            : ''
        ]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addToBag(_ctx.product)))
          }, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.setButtonText(_ctx.product)), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "card__button-remove",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeFromBag(_ctx.product)))
          }, _hoisted_14))
    ])
  ], 2))
}